import ApiService from "../api";

export default class GreenmileService extends ApiService {

    constructor() {
        super("/api/greenmile");
    }

    importar(data) {
        return this.post(`/upload`, data)
    }

    listarRotas(filtro) {
        return this.post("/listar", filtro);
    }

    editar(data) {
        return this.put("", data);
    }


    listar(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);

        if (values.filialId) params.append('filialId', values.filialId);

        return this.get(`?${params.toString()}`)
    }


    relatorio(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);

        if (values.filialId) params.append('filialId', values.filialId);

        return this.get(`/relatorio?${params.toString()}`)
    }

    listarOperacoesPorPeriodo(dataInicio, dataFim) {
        return this.get(`/dias-operacao/periodo?inicio=${dataInicio}&fim=${dataFim}`);
    }
}
